import React from 'react';
import { FiX } from 'react-icons/fi';
import { useLoadingContext } from '../../login/context/LoadingContext.tsx';
import Loading from '../loading/Loading.tsx';
import './confirm-modal.scss';

interface ConfirmModalProps {
  action: () => void;
  cancel: () => void;
  bodyText?: React.ReactNode;
  confirmText?: string;
  body?: any;
}

const ConfirmModal = ({
  action,
  cancel,
  bodyText,
  confirmText,
  body,
}: ConfirmModalProps) => {
  const { isLoading } = useLoadingContext();

  return (
    <div className="modal-overlay" onClick={cancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {isLoading ? (
          <Loading fullScreen={false} />
        ) : (
          <>
            <button className="modal-close-btn" onClick={cancel}>
              <FiX size={20} />
            </button>
            <p style={{ whiteSpace: 'pre-line' }}>{bodyText}</p>
            {body && body}
            <div className="modal-buttons">
              <button className="cancel-button" onClick={cancel}>
                Cancelar
              </button>
              <button className="confirm-button" onClick={action}>
                {confirmText}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
